import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import ItemRow from '../ItemRow'
import { ConnectorPinsContext } from '../context/context'

const PinRow = (props) => {
  const [state, dispatch] = useContext(ConnectorPinsContext)
  const { name, value, description, harnessName, circuitId, inputName } = props

  const checkBoxHandler = (evt) => {
    const { value, circuitId } = props

    const checkboxValue = evt.target.checked

    if (checkboxValue) {
      dispatch({ type: 'selected_pins', data: `${name}**$$${circuitId}` })
    } else {
      dispatch({ type: 'selected_pins', data: `${name}**$$${circuitId}` })
    }
  }

  return (
    <ItemRow
      name={name}
      inputName={inputName}
      value={value}
      onChange={(e) => checkBoxHandler(e)}
      description={description}
      isChecked={
        state?.selected_pins?.length > 0
          ? state?.selected_pins?.includes(`${name}**$$${circuitId}`)
          : false
      }
    >
      {harnessName && (
        <div className="text-xs break-all">HS: {harnessName}</div>
      )}
    </ItemRow>
  )
}

PinRow.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  description: PropTypes.string,
  harnessName: PropTypes.string,
  checked: PropTypes.bool,
  circuitId: PropTypes.string,
}

export default PinRow
